import * as React from 'react'

import { IProfile } from 'main/gql/profile'
import { schoolPagePath } from 'main/routes'
import { spacing } from 'main/ui'
import { ScheduleTourModal_school } from '../gql'
import {
  Container,
  DirectorLabel,
  DirectorText,
  ProfileImage,
  SchoolLink,
} from './SchoolSummary.styles'

interface IProps {
  school: ScheduleTourModal_school
  showPhoto: boolean
}

export default function SchoolSummary(props: IProps) {
  const { school, showPhoto } = props
  const { director, profile } = school

  return (
    <Container>
      {showPhoto && profile && (
        <div css={{ marginBottom: spacing.minorScale(1) }}>
          {<Photo profile={profile} school={school} />}
        </div>
      )}
      <SchoolLink href={schoolPagePath(school)} target="_blank">
        {school.name}
      </SchoolLink>
      <div>
        <DirectorLabel>Director:&nbsp;</DirectorLabel>
        <DirectorText>{director && director.name}</DirectorText>
      </div>
    </Container>
  )
}

function Photo(props: { profile: IProfile; school: ScheduleTourModal_school }) {
  const { profile, school } = props
  const { primaryProfileMedia } = profile
  const primary = primaryProfileMedia[0]
  if (!primary) return null

  return (
    <ProfileImage
      src={`${primary.media.url}-/format/auto/-/scale_crop/110x110/`}
      onClick={() => window.location.assign(schoolPagePath(school))}
    />
  )
}

SchoolSummary.defaultProps = {
  showPhoto: true,
}
